import { CommandButtonProps, CommandButton as RemmirorCommandButton } from '@remirror/react';
import React, { FC } from 'react';

export type ICommandButtonProps = CommandButtonProps;

export const CommandButton: FC<ICommandButtonProps> = (props) => {
  return <RemmirorCommandButton {...props} sx={{}} />;
};
